/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  SearchMonitorRequestLogsMutationRequest,
  SearchMonitorRequestLogsMutationResponse,
  SearchMonitorRequestLogsPathParams,
  SearchMonitorRequestLogs401,
  SearchMonitorRequestLogs404,
} from '../types/SearchMonitorRequestLogs.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getSearchMonitorRequestLogsUrl(id: SearchMonitorRequestLogsPathParams['id']) {
  const res = { method: 'POST', url: `/v1/monitors/${id}/request-logs/search` as const };
  return res;
}

/**
 * @summary Search request logs for a monitor
 * {@link /v1/monitors/:id/request-logs/search}
 */
export async function searchMonitorRequestLogs(
  id: SearchMonitorRequestLogsPathParams['id'],
  data: SearchMonitorRequestLogsMutationRequest,
  config: Partial<RequestConfig<SearchMonitorRequestLogsMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    SearchMonitorRequestLogsMutationResponse,
    ResponseErrorConfig<SearchMonitorRequestLogs401 | SearchMonitorRequestLogs404>,
    SearchMonitorRequestLogsMutationRequest
  >({ method: 'POST', url: getSearchMonitorRequestLogsUrl(id).url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
